var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spacer-b30"},[_c('div',{staticClass:"tagline"},[_c('span',[_vm._v(_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }